import map from './map';
import seq from './seq';
import str from './string';
export default [map, seq, str];